import { AnalyticsEventSource } from '@atlassian/temp-analytics';
import { GlobalPageLoadExperience, untilAll } from '@atlassian/ufo';

export const startGlobalPageLoadExperience = (source: AnalyticsEventSource) => {
  GlobalPageLoadExperience.updateConfig({
    // GlobalPageLoadExperience will wait for transition until all
    // dependent experiences with 'PRODUCT' category transition
    until: untilAll([{ category: 'PRODUCT' }]),
  });
  GlobalPageLoadExperience.startPageLoad(source);
};
